import {ISummarizedRecruiter} from "api/types";
import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import {handleError} from "helpers/errors";
import {AwaitableModal} from "hooks/useAwaitableModal";

interface Props {
  profiles: ISummarizedRecruiter[];
  title: string;
}

const UsersByCreatedDate: AwaitableModal<undefined, Props> = ({open, resolve, initialData}) => {
  const sortedProfiles = initialData?.profiles
    .slice(0)
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  const onClose = () => resolve();

  const onCopyEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    handleError("Email copied to clipboard");
  };

  return (
    <Modal open={open} close={onClose}>
      <ModalLayout
        title={`${initialData?.title ?? ""} (${sortedProfiles?.length ?? 0})`}
        scrollable
        footer={
          <button onClick={onClose} className="btn-primary ml-auto">
            Done
          </button>
        }
      >
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-brand-muted">
              <th className="pb-2 font-semibold">Name</th>
              <th className="pb-2 font-semibold">Email</th>
              <th className="pb-2 font-semibold">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-border">
            {sortedProfiles?.map((profile) => (
              <tr key={profile.id}>
                <td className="py-2 pr-3 text-brand-navy">{profile.name}</td>
                <td
                  className="py-2 pr-3 max-w-[16rem] truncate text-brand-amber hover:underline cursor-pointer"
                  onClick={() => onCopyEmail(profile.email)}
                >
                  {profile.email}
                </td>
                <td className="py-2 text-brand-muted whitespace-nowrap">
                  {new Date(profile.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </ModalLayout>
    </Modal>
  );
};

export default UsersByCreatedDate;
